import {LoginResponse, RegisterResponse, User} from "./Models";
import {API_BASE} from "./ApiClient";

import axios, {AxiosResponse} from 'axios';

export default class UserApi {
  private jwtToken: string|null

  constructor(jwtToken: string|null) {
    this.jwtToken = jwtToken
  }

  me(): Promise<User> {
    return axios.get(API_BASE + '/users/me', {
      headers: {
        'Authorization': 'Bearer ' + this.jwtToken
      }
    })
      .then((response: AxiosResponse<User>) => {
        return response.data;
      })
  }

  login(username: string, password: string): Promise<LoginResponse> {
    return axios.post(API_BASE + '/access/login', {
      username,
      password
    })
      .then((response: AxiosResponse<LoginResponse>) => {
        return response.data
      })
  }

  register(username: string, password: string): Promise<RegisterResponse> {
    return axios.post(API_BASE + '/access/register', {
      username,
      password
    })
      .then((response: AxiosResponse<RegisterResponse>) => {
        return response.data;
      })
  }
};